import { render, staticRenderFns } from "./searchModule.vue?vue&type=template&id=288bfb60&scoped=true&"
import script from "./searchModule.vue?vue&type=script&lang=ts&"
export * from "./searchModule.vue?vue&type=script&lang=ts&"
import style0 from "./searchModule.vue?vue&type=style&index=0&id=288bfb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bfb60",
  null
  
)

export default component.exports